import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = '/api';

const VerifyAdditionalEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/accounts/emails/verify/`, {
          token: token
        });

        setStatus('success');
        setMessage(response.data.message);

        // Redirect to profile after 3 seconds
        setTimeout(() => {
          navigate('/profile', { state: { additionalEmailVerified: true } });
        }, 3000);
      } catch (err) {
        setStatus('error');
        if (err.response?.data?.token) {
          setMessage(Array.isArray(err.response.data.token)
            ? err.response.data.token[0]
            : err.response.data.token);
        } else {
          setMessage('An error occurred while verifying your email. Please try again.');
        }
      }
    };

    if (token) {
      verifyEmail();
    }
  }, [token, navigate]);

  return (
    <div className="verify-email-page">
      <div className="container" style={{ maxWidth: '500px', margin: '60px auto', padding: '40px', textAlign: 'center' }}>
        {status === 'verifying' && (
          <>
            <div style={{
              fontSize: '48px',
              marginBottom: '20px',
              animation: 'spin 1s linear infinite'
            }}>
              ⏳
            </div>
            <h1 style={{ marginBottom: '20px' }}>Verifying Your Email...</h1>
            <p style={{ color: '#999' }}>
              Please wait while we verify your additional email address.
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: '48px', marginBottom: '20px', color: 'var(--pink)' }}>
              ✓
            </div>
            <h1 style={{ marginBottom: '20px', color: 'var(--pink)' }}>Email Verified!</h1>
            <p style={{ color: '#666', marginBottom: '20px' }}>
              {message}
            </p>
            <p style={{ color: '#999' }}>
              Redirecting you to your account page...
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: '48px', marginBottom: '20px', color: '#f44336' }}>
              ✗
            </div>
            <h1 style={{ marginBottom: '20px', color: '#f44336' }}>Verification Failed</h1>
            <p style={{ color: '#666', marginBottom: '30px' }}>
              {message}
            </p>
            <button
              onClick={() => navigate('/profile')}
              style={{
                padding: '15px 30px',
                fontSize: '18px',
                border: 'none',
                outline: 'none',
                borderRadius: '8px',
                background: 'linear-gradient(135deg, var(--pink) 0%, var(--violet) 100%)',
                color: '#fff',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 4px 15px rgba(216, 134, 255, 0.4)',
                transition: 'all 0.3s ease',
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(216, 134, 255, 0.6)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(216, 134, 255, 0.4)';
              }}
            >
              Go to My Account
            </button>
          </>
        )}

        <style>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default VerifyAdditionalEmail;
